import { getProjectManager, HEALTHCHECK_NAMES } from 'domain/shared/newProject';
import ProjectManagementSections from './sections/ProjectManagementSections';
import ProjectManagementHealthchecks from './ProjectManagementHealthchecks';
import BaseControl from '../BaseControl';
import { resolveControlsZone } from '../utils';
import { ControlData } from '../types';

type PMControlProps = {
  data: ControlData;
  refetchControlsData: () => Promise<unknown>;
  showSections?: boolean;
};

export const projectManagementHealthcheckNames = [
  HEALTHCHECK_NAMES.CUSTOMER_REPORT,
  HEALTHCHECK_NAMES.PROJECT_MANAGEMENT_RISKS,
  HEALTHCHECK_NAMES.MILESTONES,
  HEALTHCHECK_NAMES.BUSINESS_OUTCOMES,
  HEALTHCHECK_NAMES.STAKEHOLDERS,
  HEALTHCHECK_NAMES.BUDGET_FORECAST_DATE,
  HEALTHCHECK_NAMES.BUDGET_FORECAST_VALUE,
  HEALTHCHECK_NAMES.PROGRESS_DATE,
  HEALTHCHECK_NAMES.PROGRESS_VALUE,
  HEALTHCHECK_NAMES.TIMELINE_DATE,
  HEALTHCHECK_NAMES.TIMELINE_VALUE,
] as const;

const ProjectManagementControl = ({ data, refetchControlsData, showSections = true }: PMControlProps) => {
  const projectManager = getProjectManager(data);
  const zone = resolveControlsZone({
    healthChecks: data?.health?.healthChecks,
    healthcheckNames: [...projectManagementHealthcheckNames],
  });
  return (
    <BaseControl
      title="Project management"
      controlResponsible={projectManager}
      zone={zone}
      healthchecks={<ProjectManagementHealthchecks data={data} refetchControlsData={refetchControlsData} />}
      sections={
        showSections ? <ProjectManagementSections data={data} refetchControlsData={refetchControlsData} /> : null
      }
    />
  );
};
export default ProjectManagementControl;
